import { Card } from "@/components/ui/card";
import { ApiKeysManager } from "./ApiKeysManager";

export function ProfileApiKeysSection() {
	return (
		<Card className="p-4 sm:p-6">
			<ApiKeysManager
				heading="API Keys"
				description="Let external apps create tickets and tasks in your projects."
			/>
		</Card>
	);
}
